const ambientePro = true; 
export const ipServer = ambientePro ? process.env.VUE_APP_API_PRO : process.env.VUE_APP_API_DEV ;

export const getIpClient = 'https://api.ipify.org?format=json';
export const apiPromociones = ipServer + '/promociones';
export const mantVisitas = apiPromociones + '/mantVisitas';
export const mantDescCliente = apiPromociones + '/mantDescCliente';
export const registraClienteDesc = apiPromociones + '/registraClienteDesc';
export const getTipoPromo = apiPromociones + '/getTipoPromo';
export const registraClienteSorteo = apiPromociones + '/registraClienteSorteo';

